import { render, staticRenderFns } from "./mini-ad.vue?vue&type=template&id=22bb1022&scoped=true&"
import script from "./mini-ad.vue?vue&type=script&lang=ts&"
export * from "./mini-ad.vue?vue&type=script&lang=ts&"
import style0 from "./mini-ad.vue?vue&type=style&index=0&id=22bb1022&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bb1022",
  null
  
)

export default component.exports